import React, { useEffect, useState } from "react";
import { CardBody, Row, Col } from "reactstrap";
import { CardStyled, Link } from "./styles";

import { LinkStyled } from "views/pages/styles";

export default function CardMultistore({ multistore, multistores }) {
  const image = multistore.avatar ? multistore.avatar.url : "";
  const username = multistore.name.replace(/^deleted\d+-/,'');
  const email = multistore.email.replace(/^deleted\d+-/,'');

  const createdAt = new Date(multistore.created_at);

  return (
    <>
      <CardStyled>
        <CardBody>
          <Row>
            <Col md="3" style={{ margin: "auto" }}>
              {image !== "" ? <img alt="..." src={image} /> : <p>Sem foto</p>}
            </Col>
            <Col md="9">
              <h6>{multistore.fantasy_name}</h6>
              <span>{username}</span>
              <p>{email}</p>

              <div>
                Criado em:{" "}
                {createdAt.toLocaleDateString("pt-BR", { timeZone: "UTC" })}
              </div>
              <div>
                {multistore.children.length === 0 ? (
                  <b> Sem lojas associadas </b>
                ) : (
                  <>
                    <b> Lojas: </b> {multistore.children.map((c) => c.name).join(', ')}
                  </>
                )}
              </div>
            </Col>
          </Row>

          <hr />
          <LinkStyled
            to={{
              pathname: `/multistores/edit/${multistore.id}`,
              state: { multistore },
            }}
          >
            Editar
          </LinkStyled>
        </CardBody>
      </CardStyled>
    </>
  );
}
